import { List, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MapLayers } from 'features/mapping/mapping.constants';
import {
  LightningNegativePolarityIcon,
  LightningPositivePolarityIcon,
} from 'features/mapping/icons/iconData/lightningIcons';
import { LegendSectionTitle } from 'features/mapping/components/LegendDrawerContent/LegendSectionTitle';
import { LegendListItem } from './LegendListItem';

export const LightningLegend = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <List
      disablePadding
      dense
      subheader={
        <LegendSectionTitle>
          {t('map.legends.lightning.title')}
        </LegendSectionTitle>
      }
    >
      <LegendListItem
        mapLayer={MapLayers.LIGHTNING}
        iconSrc={LightningNegativePolarityIcon.data}
        iconSize={26}
        primaryText={t('map.legends.lightning.legends.negative.title')}
        secondary={
          <Typography variant="body2">
            {t('map.legends.lightning.legends.negative.subtitle')}
          </Typography>
        }
      />
      <LegendListItem
        mapLayer={MapLayers.LIGHTNING}
        iconSrc={LightningPositivePolarityIcon.data}
        iconSize={26}
        primaryText={t('map.legends.lightning.legends.positive.title')}
        secondary={
          <Typography variant="body2">
            {t('map.legends.lightning.legends.positive.subtitle')}
          </Typography>
        }
      />
    </List>
  );
};
